import React from 'react';

import Icon from '../Icon/Icon';

const BigCloudIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g strokeWidth='2' fill='none' fillRule='evenodd'>
                <path
                    d='M30.333 14c2.41 0 4.593.962 6.173 2.52a8.489 8.489 0 0 1 1.83 9.485c.228.113.448.244.656.392A4.718 4.718 0 0 1 41 30.25a4.692 4.692 0 0 1-1.345 3.288 4.855 4.855 0 0 1-3.284 1.458L12.917 35a6.026 6.026 0 0 1-3.51-1.975A5.669 5.669 0 0 1 8 29.292c0-1.137.338-2.197.92-3.086a5.805 5.805 0 0 1 2.998-2.314 6.634 6.634 0 0 1 2.388-4.495 6.817 6.817 0 0 1 4.36-1.564 6.843 6.843 0 0 1 3.761 1.12c.137-.288.29-.567.458-.838A8.747 8.747 0 0 1 30.333 14z'
                    stroke='#34303D'
                />
                <path
                    d='M34.573 25.017c.276-.616.43-1.297.43-2.013 0-2.754-2.27-4.987-5.067-4.987a5.078 5.078 0 0 0-4.436 2.575M14.816 26.982a2.066 2.066 0 1 0 0 4.132M15.04 31.15h13'
                    stroke='#FFF'
                    strokeLinecap='round'
                />
            </g>
        </Icon>
    );
};

export default BigCloudIcon;
